<template>
  <div>
    <claimOrder-list v-show="tabType === 1" @handleShow="handleShow" />
    <claimOrder-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import claimOrderList from './list.vue'
import claimOrderShow from './show.vue'
export default {
  components: { claimOrderList, claimOrderShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>